import { Search } from '@/types/constants/routes/search';
import { RouteConfig } from 'vue-router';

export const SearchRoutes = [
  {
    ...Search.Criteria,
    component: () => import('@/views/search/SearchCriteria.vue'),
    meta: {
      title: 'Search'
    }
  },
  {
    ...Search.Results,
    component: () => import('@/views/search/SearchResults.vue'),
    props: (route) => ({ ...route.params, savedSearchId: Number(route.params.savedSearchId) || undefined }),
    meta: {
      title: 'Search Results',
      key: 'SearchResults'
    }
  },
  {
    ...Search.DefaultDocumentView,
    component: () => import('@/views/search/DefaultDocumentView.vue'),
    meta: {
      title: 'View Document'
    }
  }
] as RouteConfig[];
